let language = {
    "menu:part:catalog": "Catalog",
    "route:newProduct": "New products",

    "btn_signup": "sign up",
    "btn_signin": "sign in",
    "btn_signout": "sign out",
}

export { language }